import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { To, useNavigate, useParams } from 'react-router-dom'

import { Intent, ProgressBar } from '@blueprintjs/core'

import card from '../../domain/api/card'
import styles from './CardView.module.scss'

export default (props: {
    redirectIfProfileLinked: (profileId: string) => To,
    redirectIfProfileNotLinked: (cardId: string) => To,
}) => {
    const { cardId } = useParams()
    const { data, isLoading } = card.useFetchSWR(cardId)
    const { t } = useTranslation()
    const navigate = useNavigate()

    // redirect to profile page if profile is linked
    useEffect(() => {
        if (!data) return
        if (data?.profile_id) navigate(props.redirectIfProfileLinked(data.profile_id))
        else navigate(props.redirectIfProfileNotLinked(data.id))
    }, [data, navigate, props])

    return <>
        {isLoading &&
            <div className={styles.container}>
                <p>{t('cardView.redirectingDescription')}</p>
                <ProgressBar
                    value={1}
                    intent={Intent.SUCCESS}
                />
            </div>
        }
    </>
}
